import React, { Component } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment'
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';
export default class  Stage2ViewAuditObservation extends Component {
    constructor(props) { 
        super(props)
        this.state = {
        //   orgCode : props.match.params.orgcode,
        //   stage2auditobsturl: "",
        uploadStatus :  true,
        reportOfauditobservationProcess: {
            orgCode : props.match.params.orgcode,
            stage2auditobsturl: "",
          
        },
          data: {},
          config: {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            dirName: process.env.REACT_APP_DIR_NAME /* optional */,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_ID,
            secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
        },
        buttonStatus: "none",
        downloadbuttonStatus: "none",
        uploadDocumentStatus: "none",
        uploadedDocumentStatus: "none",
        showFile: "Image",
        uploadedProcessUrl: "",
        submitStatus: false,
        editStatus: "block",
        messageforvalidation :"none",
        isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
       const api = APIURL + '/api/stagetwo/get/stagetwodata/' + this.state.reportOfauditobservationProcess.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
            console.log("data ",res.data.response)
            if (res.data.errorCode === 0) {
                this.setState({ data: res.data.response });
                if ( this.state.data.stage2auditobsturl) {
                    var uplodedFileName= this.state.data.stage2auditobsturl.split("/")
                            var uplodedFileNameToView = uplodedFileName[4]
                    this.setState({ uploadedProcessUrl: this.state.data.stage2auditobsturl })
                    this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none",uploadedFileNameToshow: uplodedFileNameToView ,editStatus: "none", })
                }
                else if (! this.state.data.stage2auditobsturl) {
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block",editStatus: "block" })
                }
             
            }
          })
          .catch(e => {
            console.log("Something went Wrong", e)
            var string = JSON.stringify(e).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);

            console.log("found", found);
            if (found !== null) {
                window.location.href = "/signin"

                this.setState({isLoading:true})
            }
        })
      }
      handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                console.log("data s3",data)
                var tempData =this.state.reportOfauditobservationProcess;
                tempData.stage2auditobsturl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ stage2auditobsturl: tempData, 
                                showFile: docType,
                                uploadStatus: false,
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName
                             });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    }; 

    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }

    removeDoc = () => {
        var tempData = this.state.reportOfauditobservationProcess;
        tempData.stage2auditobsturl = ""
        this.setState({  reportOfauditobservationProcess: tempData ,uploadStatus: true });
    }
    removeUplodedDoc = () => {
      
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                        "orgCode":this.state.reportOfauditobservationProcess.orgCode,
                     
                   }
 
   axios.patch(APIURL + "/api/stagetwo/patch/deleteauditobservationurl",jsonRequest)
   .then((res) => {
       if (res.data.errorCode === 0) {
     
           this.setState({
               uploadDocumentStatus: "block",
               uploadedDocumentStatus: "none",
               uploadProcessUrl: "",
               uploadStatus: true,
               uploadedProcessUrl: "",
               editStatus: "block"
           })
       }
       else {
           ToastInstance('Error', 'Something Went Wrong')
       }
   })
   .catch(err => {
       ToastInstance('warning', 'Something Went Wrong..Please Try again')
   })
                   

                }
            })
    }
    
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/stage2auditobservationsheet/' +this.state.reportOfauditobservationProcess.orgCode;
    }

    generateReviewProcess = () => {
     
        return axios.get(APIURL+'/api/generatepdf/get/auditobservationsheet/' + this.state.reportOfauditobservationProcess.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.reportOfauditobservationProcess.orgCode + '- Stage Two Audit Observation' + `.pdf`
                link.click()
            })


    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfauditobservationProcess.orgCode,
            stage2auditobsturl: this.state.reportOfauditobservationProcess.stage2auditobsturl,
        }
        console.log("json",jsonRequest)
        axios.patch(APIURL + "/api/stagetwo/patch/stage2auditobsturl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    this.setState({uploadStatus: true})
                    ToastInstance('Success', 'Stage2 Audit Observation Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
      

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
    }
    render() {
         const FileAuditObservationProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfauditobservationProcess.stage2auditobsturl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadUploadPdf()}/>
                    <span>
                        <h6 onClick={() => this.removeDoc('stage2auditobsturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                <div className="row">
                <div className="col-sm-12">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={()=>this.downloadUploadPdf()}/>
                        <span>
                            <h6 onClick={() => this.removeDoc('stage2auditobsturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                        </span>
                        </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
    return (
        <div>
             <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body" style={{ paddingLeft: "4%", paddingRight:"4%"}}>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                            <div className="row">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Organization</label>
                                                                <div className="col-sm-9">
                                                                 <p>{this.state.data.orgName}</p>
                                                                   
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                                <div className="col-sm-9">
                                                                 <p>{this.state.data.address}</p>
                                                                </div>
                                                                </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Site Address (If any)</label>
                                                                <div className="col-sm-3">
                                                                    <p >{this.state.data.siteofaddress}</p>
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Employees</label>
                                                                <div className="col-sm-3">
                                                                    <p >{this.state.data.effectiveNoEmpToBeAudited}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Email id </label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.email}</p>
                                                                </div>
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact Person </label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.contactPersonName}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Telephone/Fax</label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.mobile}</p>
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">ANZSIC Code / NACE CODE</label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.nabcbcodeName}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope </label>
                                                                <div className="col-sm-9">
                                                                 <p>{this.state.data.scope}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-3">
                                                            <div className="col-sm-7 text-dark">
                                                                    <label htmlFor="staticEmail" className=" labelsize">Non applicable requirements as determined by organisation: </label>
                                                                </div>
                                                                <div className="col-sm-5">
                                                                    <p>All Clauses are applicable</p>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="row">
                                                                        <label htmlFor="staticEmail" className="col-sm-7 labelsize">Justification for Non applicability checked and accepted?</label>
                                                                        <div className="col-sm-5">
                                                                           <p>{this.state.data.gpPvtHealthSubCenterOptions}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="row">
                                                                        <label htmlFor="staticEmail" className="col-sm-7 labelsize">Type Of Audit</label>
                                                                        <div className="col-sm-5">
                                                                         <p>{this.state.data.typeofaudit}</p>
                                                                        </div>
                                                                    </div>
                                                                    <p className="mt-4"><b>Note: </b><i>Combined/Joint/integrated audit(If Applicable) </i></p>

                                                                </div>
                                                            </div>
                                                            <hr />

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Significant Changes(if any),Since last audit that affects QMS</label>
                                                                <div className="col-sm-9">
                                                                 <p>{this.state.data.significantchanges}</p>
                                                                </div>

                                                               
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.teamleaderName}</p>
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical Expert</label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.technicalExpertName === null ? "-":this.state.data.technicalExpertName}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                              
                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Observation Date:</label>
                                                                <div className="col-sm-3 mt-2" >
                                                                 <p>{moment(this.state.data.datestage2observation).format('DD-MMM-YYYY')}</p>
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Place of the Audit</label>
                                                                <div className="col-sm-3">
                                                                 <p>{this.state.data.placeofaudit}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any Deviation in the Audit Plan and Reason(if any) </label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.anydeviationinauditplan}</p>
                                                                </div>

                                                                
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Brief about the organization </label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.briefaboutorg}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any Significant issue impacting on the Audit Programme</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.anysignificantissue}</p>
                                                                </div>
                                                                </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any unresolved issues(if identified)</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.anyunresolved}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Criteria of Audit(Disclaimer Statement)</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.criteriaofaudit}</p>
                                                                </div>
                                                                </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Objective of Audit</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.objectiveofaudit}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Verification of effectiveness of NC closure of Stage 1 Audit(If any)</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.verificationofeffectiveness}</p>
                                                                </div>
                                                            </div>

                                                            <hr />
                                                            <div className="row mt-2">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">External Issues</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.externalissues}</p>
                                                                </div>
                                                                </div>

                                                                <div className="row mt-2">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Internal Issues</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.internalissues}</p>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-2">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Needs and Expectations of interested parties</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.needsandexpectations}</p>
                                                                </div>
                                                                </div>


                                                                <div className="row mt-2">
                                                                <label htmlFor="staticEmail" className="col-sm-6 labelsize">Risk & Opportunity & Change Control</label>
                                                                <div className="col-sm-12">
                                                                 <p>{this.state.data.riskandopportunity}</p>
                                                                   
                                                                </div>
                                                            </div>

                                                            
                                                            <div >
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Download Stage2 Audit Observation Report</h5>
                                                                    </div>
                                                                    <div className="col-sm-5 mb-2" style={{textAlign:"right"}}>
                                                                    <button className="btn btn-primary col-sm-3" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                </div>
                                                                    <hr />

                                                                    {/* <div className="row">
                                                                        <div className="col-sm-10" />
                                                                       
                                                                        <button className="btn btn-primary col-sm-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                    </div> */}
                                                                </div>
                                                                </div>
                                                                {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                                            ""
                                                                            :
                                                                    <div style={{ display: this.state.uploadDocumentStatus }}>
                                                                            <div className="row mt-4">
                                                                                <hr className="mt-4" />
                                                                                <div className="col-sm-6 text-dark ">
                                                                                    <h5>Upload  Stage2 Audit Observation Report</h5>
                                                                                </div>
                                                                    <hr />


                                                
                                                       <div className="row mt-5" >
                                                           <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload  Stage2 Audit Observation Report </label></div>
                                                           <div className="col-sm-6">
                                                           <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                               {
                                                                  this.state.reportOfauditobservationProcess.stage2auditobsturl !== "" ?
                                                                       <FileAuditObservationProcess />
                                                                       :
                                                                       <>
                                                                           <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                           <br></br>

                                                                       </>
                                                               }
                                                           </div>
                                                           </div>
                                                           <div className="row">
                                                       <div className="col-sm-10" />
                                                       <button type="button" className="btn btn-sm btn-success col-sm-2" onClick={() => this.postData()} disabled={this.state.uploadStatus}>Upload</button>

                                                   </div>
                                                </div>
                                                       </div>
    }
                                                       
                                                  
                                                   <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Stage2 Audit Observation Report</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4">
                                                                Uploaded  Stage2 Audit Observation Report
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                       
                                                                       
                                                                       
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                            
                                                                            {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    { 
                                localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts" || localStorage.getItem("userRole")==="Executive(Support)"?
                                ""
                                :
                                <div className="card-footer">
                                <div className="row">
                                <div className="col-lg-11"></div>
                                <div className="col-lg-1" style={{ marginBottom: "10PX" }}>

                                    <button type="submit" className="btn btn-primary" onClick={() => this.handleRoute()} style={{display : this.state.editStatus}}>Edit</button>

                                </div>
                                </div>
                            </div>
                     }
        </div>
   
   )
}
}

